import { createAsyncThunk } from '@reduxjs/toolkit'
import { sendAsync } from '../../app/applicationSlice'
import { RootThunkApi } from '../../app/store'

import * as S from '../../services/chain'
import { putstorageDetail } from '../../services/putstorage'
import {
  ExportExcelParams,
  storedetailRemove,
} from '../../services/storedetail'
import {commodityExportExcel, commodityPageParams} from "../../services/commodity";
import {purchaseBusinessExportExcel} from "../../services/chain";

// 列表
export const getchainInventoryReceiptslist = createAsyncThunk<
  void,
  S.ChainInventoryReceiptsParams,
  RootThunkApi
>('chain/chainInventoryReceipts', async (params, api) => {
  return sendAsync(S.getChainInventoryList(params), api)
})

// 调拨出库导出
export const getExportExcelDBCKAsync = createAsyncThunk<
  void,
  S.ChainInventoryReceiptsParams,
  RootThunkApi
>('/commodity/commodityExportExcelAsync', async (params, api) => {
  return sendAsync(S.getExportExcelDBCK(params), api)
})

//中药清斗单导出
export const getExportExcelAsync = createAsyncThunk<void, any, RootThunkApi>(
  '/chain/exportExcel',
  async (body, api) => {
    return sendAsync(S.getExportExcel(body), api)
  }
)

// 药店导出总部
export const getYDExportExcelAsync = createAsyncThunk<
  void,
  S.YDExportExcelParams,
  RootThunkApi
>('/chain/getYDExportExcelAsync', async (body, api) => {
  return sendAsync(S.getYDExportExcel(body), api)
})

// 药店导出分部
export const getYDExportExcelFBAsync = createAsyncThunk<
  void,
  S.YDExportExcelFBParams,
  RootThunkApi
>('/chain/getYDExportExcelFBAsync', async (body, api) => {
  return sendAsync(S.getYDExportExcelFB(body), api)
})

// 采购明细导出
export const getExportExcelCGMX = createAsyncThunk<
  void,
  S.YDExportExcelFBParams,
  RootThunkApi
>('/chain/getExportExcelCGMX', async (body, api) => {
  return sendAsync(S.getExportExcelCGMX(body), api)
})

// 审核
export const getSubmitForReviewFn = createAsyncThunk<void, any, RootThunkApi>(
  'chain/getSubmitForReview',
  async (params, api) => {
    return sendAsync(S.getSubmitForReview(params), api)
  }
)

// 入库
export const getReceiptConfirmFn = createAsyncThunk<void, any, RootThunkApi>(
  'chain/getReceiptConfirm',
  async (params, api) => {
    return sendAsync(S.getReceiptConfirm(params), api)
  }
)

// 采购入库
export const getQueryInboundFn = createAsyncThunk<void, any, RootThunkApi>(
  'chain/getQueryInbound',
  async (params, api) => {
    return sendAsync(S.getQueryInbound(params), api)
  }
)

// 收货
export const getReturnDeliveryFn = createAsyncThunk<void, any, RootThunkApi>(
  'chain/getReturnDelivery',
  async (params, api) => {
    return sendAsync(S.getReturnDelivery(params), api)
  }
)

// 采购确认入库
export const queryInboundOperateInventoryFn = createAsyncThunk<
  void,
  any,
  RootThunkApi
>('chain/queryInboundOperateInventory', async (params, api) => {
  return sendAsync(S.queryInboundOperateInventory(params), api)
})

// 发货
export const getReturnReceiptFn = createAsyncThunk<void, any, RootThunkApi>(
  'chain/getReturnReceipt',
  async (params, api) => {
    return sendAsync(S.getReturnReceipt(params), api)
  }
)

// 采购退货确认
export const queryOutboundOperateInventoryFn = createAsyncThunk<
  void,
  any,
  RootThunkApi
>('chain/queryOutboundOperateInventory', async (params, api) => {
  return sendAsync(S.queryOutboundOperateInventory(params), api)
})

// 出库
export const getDeliveryFn = createAsyncThunk<void, any, RootThunkApi>(
  'chain/getDelivery',
  async (params, api) => {
    return sendAsync(S.getDelivery(params), api)
  }
)

// 拒绝
export const getReviewRejectedFn = createAsyncThunk<
  void,
  S.ReviewRejectedParams,
  RootThunkApi
>('chain/getReviewRejected', async (params, api) => {
  return sendAsync(S.getReviewRejected(params), api)
})

// 通过
export const getApprovedFn = createAsyncThunk<void, any, RootThunkApi>(
  'chain/getApproved',
  async (params, api) => {
    return sendAsync(S.getApproved(params), api)
  }
)

// 详情
export const getPutstorageDetailFn = createAsyncThunk<
  void,
  number,
  RootThunkApi
>('chain/putstorageDetail', async (params, api) => {
  return sendAsync(putstorageDetail(params), api)
})

// 调拨详情
export const getCalcStockByApplyReceiptsFn = createAsyncThunk<
  void,
  number,
  RootThunkApi
>('chain/calcStockByApplyReceipts', async (params, api) => {
  return sendAsync(S.getCalcStockByApplyReceipts(params), api)
})

// 删除
export const getStoredetailRemoveFn = createAsyncThunk<
  void,
  string,
  RootThunkApi
>('chain/storedetailRemove', async (params, api) => {
  return sendAsync(storedetailRemove(params), api)
})

// list删除
export const getRemoveReceiptsFn = createAsyncThunk<void, number, RootThunkApi>(
  'chain/getRemoveReceipts',
  async (params, api) => {
    return sendAsync(S.getRemoveReceipts(params), api)
  }
)

// 删除采购
export const getPurchaseBusinessRemoveFn = createAsyncThunk<void, number, RootThunkApi>(
  'chain/getPurchaseBusinessRemoveFn',
  async (params, api) => {
    return sendAsync(S.getPurchaseBusinessRemove(params), api)
  }
)

// 验收撤销
export const getInventorypurchaseacceptancemainWithdrawFn = createAsyncThunk<void, number, RootThunkApi>(
  'chain/getInventorypurchaseacceptancemainWithdrawFn',
  async (params, api) => {
    return sendAsync(S.getInventorypurchaseacceptancemainWithdraw(params), api)
  }
)

// 采购撤回
export const getPurchaseBusinessWithdrawFn = createAsyncThunk<void, number, RootThunkApi>(
  'chain/getPurchaseBusinessWithdrawFn',
  async (params, api) => {
    return sendAsync(S.getPurchaseBusinessWithdraw(params), api)
  }
)
// 采购上传
export const getInsertInptPoFn = createAsyncThunk<void, number, RootThunkApi>(
  'chain/getInsertInptPo',
  async (params, api) => {
    return sendAsync(S.getInsertInptPo(params), api)
  }
)

// 采购退货上传
export const insertInptPktFn = createAsyncThunk<void, number, RootThunkApi>(
  'chain/insertInptPkt',
  async (params, api) => {
    return sendAsync(S.insertInptPkt(params), api)
  }
)

// 查看批次
export const getSelectChainStockOutItemFn = createAsyncThunk<
  void,
  any,
  RootThunkApi
>('chain/getSelectChainStockOutItem', async (params, api) => {
  return sendAsync(S.getSelectChainStockOutItem(params), api)
})

// 子机构
export const getChainListFn = createAsyncThunk<void, void, RootThunkApi>(
  'chain/getChainList',
  async (_, api) => {
    return sendAsync(S.getChainList(), api)
  }
)

// 所有机构
export const getChainTenantListFn = createAsyncThunk<void, void, RootThunkApi>(
  'chain/getChainTenantListFn',
  async (_, api) => {
    return sendAsync(S.getChainTenantList(), api)
  }
)

// 导出采购单
export const purchaseBusinessExportExcelAsync = createAsyncThunk<
  void,
  S.ChainInventoryReceiptsParams,
  RootThunkApi
  >('/commodity/purchaseBusinessExportExcelAsync', async (params, api) => {
  return sendAsync(S.purchaseBusinessExportExcel(params), api)
})

//手动同步目录
export const getSyncMaterialsCatalogFn = createAsyncThunk<
  void,
  void,
  RootThunkApi
>('chain/getSyncMaterialsCatalog', async (_, api) => {
  return sendAsync(S.getSyncMaterialsCatalog(), api)
})

//商品目录
export const getSynchrGoodsFn = createAsyncThunk<void, void, RootThunkApi>(
  'chain/getSynchrGoods',
  async (_, api) => {
    return sendAsync(S.getSynchrGoods(), api)
  }
)

//勾选同步商品目录
export const postTTickSynchrGoodsFn = createAsyncThunk<void, number[], RootThunkApi>(
  'chain/postTTickSynchrGoods',
  async (ids, api) => {
    return sendAsync(S.postTTickSynchrGoods(ids), api)
  }
)

//采购list
export const getPurchaseBusinessListFn = createAsyncThunk<
  void,
  S.ChainInventoryReceiptsParams,
  RootThunkApi
>('chain/getPurchaseBusinessList', async (params, api) => {
  return sendAsync(S.getPurchaseBusinessList(params), api)
})

//申领退货
export const getReturnPageFn = createAsyncThunk<
  void,
  S.ChainInventoryReceiptsParams,
  RootThunkApi
>('chain/getReturnPage', async (params, api) => {
  return sendAsync(S.getReturnPage(params), api)
})

// 采购拒绝
export const getPurchaseBusinessRejectedFn = createAsyncThunk<
  void,
  S.ReviewRejectedParams,
  RootThunkApi
>('chain/getPurchaseBusinessRejected', async (params, api) => {
  return sendAsync(S.getPurchaseBusinessRejected(params), api)
})

// 采购入库确认
export const queryInboundDAsync = createAsyncThunk<void, any, RootThunkApi>(
  'chain/queryInboundDFn',
  async (params, api) => {
    return sendAsync(S.queryInboundDFn(params), api)
  }
)

// 总，分拒绝
export const getReturnRejectedFn = createAsyncThunk<
  void,
  S.ReviewRejectedParams,
  RootThunkApi
>('chain/getReturnRejected', async (params, api) => {
  return sendAsync(S.getReturnRejected(params), api)
})

// 采购通过
export const getPurchaseBusinessApprovedFn = createAsyncThunk<
  void,
  any,
  RootThunkApi
>('chain/getPurchaseBusinessApproved', async (params, api) => {
  return sendAsync(S.getPurchaseBusinessApproved(params), api)
})

// 总，分通过
export const getReturnApprovedFn = createAsyncThunk<void, any, RootThunkApi>(
  'chain/getReturnApproved',
  async (params, api) => {
    return sendAsync(S.getReturnApproved(params), api)
  }
)

// 提交
export const getPurchaseBusinessReviewFn = createAsyncThunk<
  void,
  any,
  RootThunkApi
>('chain/getPurchaseBusinessReview', async (params, api) => {
  return sendAsync(S.getPurchaseBusinessReview(params), api)
})

// 总，分，提交
export const getReturnReviewRejectedFn = createAsyncThunk<
  void,
  any,
  RootThunkApi
>('chain/getReturnReviewRejected', async (params, api) => {
  return sendAsync(S.getReturnReviewRejected(params), api)
})

// 总，入库查询
export const getReturnItemPageFn = createAsyncThunk<
  void ,
  any,
  RootThunkApi
  >("chain/getReturnReviewRejected", async (params, api) => {
  return sendAsync(S.getReturnItemPage(params), api);
});


// 复制
export const getCopyListAsync = createAsyncThunk<
void ,
S.CopyListParams,
RootThunkApi
>("chain/getCopyListAsync", async (params, api) => {
return sendAsync(S.getCopyList(params), api);
});


// 详情
export const getCopyDetailAsync = createAsyncThunk<
void ,
S.CopyDetailParams,
RootThunkApi
>("chain/getCopyDetailAsync", async (params, api) => {
return sendAsync(S.getCopyDetail(params), api);
});


// 复制明细

export const getCopyDetailButtonAsync = createAsyncThunk<
void ,
S.CopyDetailButtonParams,
RootThunkApi
>("chain/getCopyDetailButtonAsync", async (params, api) => {
return sendAsync(S.getCopyDetailButton(params), api);
});


// 复制明细验收业务

export const getCopyDetailAcceptanceButtonAsync = createAsyncThunk<
void ,
S.CopyDetailButtonParams,
RootThunkApi
>("chain/getCopyDetailAcceptanceButtonAsync", async (params, api) => {
return sendAsync(S.getCopyDetailAcceptanceButton(params), api);
});

//验收单
export const getInventoryPurchAseacceptanceListAsync = createAsyncThunk<
void,
any,
RootThunkApi
>("chain/getInventoryPurchAseacceptanceListAsync", async (params, api) => {
return sendAsync(S.getInventoryPurchAseacceptanceList(params), api);
});

//保存验收单
export const getInventoryPurchAseacceptanceSubmitAsync = createAsyncThunk<
void,
any,
RootThunkApi
>("chain/getInventoryPurchAseacceptanceSubmitAsync", async (params, api) => {
return sendAsync(S.getInventoryPurchAseacceptanceSubmit(params), api);
});

//保存入库单
export const getInventoryPurchAseacceptanceGspSubmitAsync = createAsyncThunk<
void,
any,
RootThunkApi
>("chain/getInventoryPurchAseacceptanceGspSubmitAsync", async (params, api) => {
return sendAsync(S.getInventoryPurchAseacceptanceGspSubmit(params), api);
});

//保存入库单
export const getInventoryReceiptsSubmitAsync = createAsyncThunk<
void,
any,
RootThunkApi
>("chain/getInventoryReceiptsSubmitAsync", async (params, api) => {
return sendAsync(S.getInventoryReceiptsSubmit(params), api);
});

//验收page getAcceptancePage
export const getAcceptancePageAsync = createAsyncThunk<
void,
any,
RootThunkApi
>("chain/getAcceptancePageAsync", async (params, api) => {
return sendAsync(S.getAcceptancePage(params), api);
});

//验收明细
export const getAcceptanceDetailListAsync = createAsyncThunk<
void,
any,
RootThunkApi
>("chain/getAcceptanceDetailListAsync", async (params, api) => {
return sendAsync(S.getAcceptanceDetailList(params), api);
});

//验收明细保存
export const getAcceptanceDetailSubmitAsync = createAsyncThunk<
void,
any,
RootThunkApi
>("chain/getAcceptanceDetailSubmitAsync", async (params, api) => {
return sendAsync(S.getAcceptanceDetailSubmit(params), api);
});

//验收提交
export const getAcceptanceDetailMainSubmitAsync = createAsyncThunk<
void,
any,
RootThunkApi
>("chain/getAcceptanceDetailMainSubmitAsync", async (params, api) => {
return sendAsync(S.getAcceptanceDetailMainSubmit(params), api);
});

//验收提交备注
export const getAcceptanceDetailMainRemarkSubmitAsync = createAsyncThunk<
void,
any,
RootThunkApi
>("chain/getAcceptanceDetailMainRemarkSubmitAsync", async (params, api) => {
return sendAsync(S.getAcceptanceDetailMainRemarkSubmit(params), api);
});

//验收通过拒绝
export const getAcceptanceApproveAsync = createAsyncThunk<
void,
any,
RootThunkApi
>("chain/getAcceptanceApproveAsync", async (params, api) => {
return sendAsync(S.getAcceptanceApprove(params), api);
});

//验收删除
export const getRemoveAcceptanceAsync = createAsyncThunk<void, number, RootThunkApi>(
  'chain/getRemoveAcceptanceAsync',
  async (params, api) => {
    return sendAsync(S.getRemoveAcceptance(params), api)
  }
)

//验收明细删除
export const getRemoveAcceptanceItemAsync = createAsyncThunk<void, number, RootThunkApi>(
  'chain/getRemoveAcceptanceItemAsync',
  async (params, api) => {
    return sendAsync(S.getRemoveAcceptanceItem(params), api)
  }
)

//生成单据的接口合并 
export const getBuildOtherRecipeAsync = createAsyncThunk<void, any, RootThunkApi>(
  'chain/getBuildOtherRecipeAsync',
  async (params, api) => {
    return sendAsync(S.getBuildOtherRecipe(params), api)
  }
)